import React from 'react';
import { Modal } from 'semantic-ui-react';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import HarvestEventErrorsExistGate from 'components/HarvestEventErrorsExistGate';
import QueryStringModal from 'components/QueryStringModal';
import HarvestEventsSaveErrorForm from './components/HarvestEventsSaveErrorForm';

export const HarvestEventsSaveErrorModalComponent = (): React.ReactElement => (
    <HarvestEventErrorsExistGate>
        <QueryStringModal
            param="error"
            modalProps={{
                size: 'tiny'
            }}
        >
            <ErrorBoundary
                namespace="ErrorModal"
                FallbackComponent={<ErrorBoundaryAlert />}
            >
                <Modal.Header>Pick Upload Error</Modal.Header>
                <Modal.Content>
                    <p>
                        Sorry, there was an unexpected error while uploading
                        your recent changes. The Orchard Hand team have been
                        notified and will investigate.
                    </p>
                    <HarvestEventsSaveErrorForm />
                </Modal.Content>
            </ErrorBoundary>
        </QueryStringModal>
    </HarvestEventErrorsExistGate>
);

export default HarvestEventsSaveErrorModalComponent;
